import { MorphScheme } from "./detect-morph-scheme";

export interface SchemeProfile {
    morphDuration: number;
    scale: number;
    defaultPosition: [number, number, number];
    enableBlinking: boolean;
    blinkingClip: string;
    enableExtraLights: boolean;
    clips: {
        idle: string;
        talk: string;
        talkVariant: string;
        thinking: string;
    };
}

export const SCHEME_PROFILES: Record<MorphScheme, SchemeProfile> = {
    LEGACY: {
        morphDuration: 0.08,
        scale: 1.6,
        defaultPosition: [0, -2.57, 0],
        enableBlinking: false,
        blinkingClip: "",
        enableExtraLights: false,
        clips: {
            idle: "B_Mocap_Idle_V3",
            talk: "B_Mocap_Talk_V2",
            talkVariant: "B_Mocap_Talk_V1",
            thinking: "B_Mocap_Thinking_V6",
        },
    },
    MULTI_MESH: {
        morphDuration: 0.08,
        scale: 1.45,
        defaultPosition: [0, -2.17, -2],
        enableBlinking: true,
        blinkingClip: "EyesBlinking",
        enableExtraLights: true,
        clips: {
            idle: "Idle",
            talk: "Talking_2",
            talkVariant: "Talking_2",
            thinking: "Idle",
        },
    },
};
